import { createEntityComboBox } from './helpers/createEntityComboBox';

import { createQueryHook } from '~/shared/providers/api';
import { QueryHookResult } from '~/shared/providers/api/createQueryHook';

export type SelectableItemGroup = QueryHookResult<
  typeof useItemGroupsQuery
>[number];

export const useItemGroupsQuery = createQueryHook(
  'shared.selectItemGroup',
  (params: { ids?: string[]; searchTerm?: string }) => ({
    itemGroups: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
        },
        pagination: {
          limit: 50,
          offset: 0,
        },
      },
      entries: {
        id: true,
        name: true,
        number: true,
      },
    },
  }),
  {
    select: (data) => data?.itemGroups.entries ?? [],
  },
);

export const SelectItemGroup = createEntityComboBox.remotelySearched(
  'SelectItemGroup',
  useItemGroupsQuery,
  {
    formatLabel: (entity) => entity.name,
    formatSubLabel: (entity) => entity.number || '',
    compactSelection: true,
  },
);
